import * as types from './action-types';
// import { PanelProxy } from '../../../proxies';
import { DashboardProxy } from '../../../proxies';

const clearData = () => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({type: types.SET_SINGLE_COMPANY_DATA, payload: { data: {id:null}, key: 'companyData'}});
  });
};

const getFreeReservationCredit = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new DashboardProxy(payload.filter).add(payload).then(response => {
      dispatch({ type: `SET_COMPANY_FREECREDIT`, payload: { key: payload.key, data: response } });
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

export default {
  clearData,
  getFreeReservationCredit
}



// WEBPACK FOOTER //
// ./src/store/modules/company/actions.js